import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import InfosilemReaderForm from '../forms/infosilem-reader-form';
import { infosilemReaderValidationSchema } from '../schema/infosilemReader.js';

export default function InfosilemReader({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Infosilem Reader Node Details',
        altText: 'Infosilem Reader Node',
        defaultLabel: 'Infosilem Reader Node',
      }}
    >
      <CommonNode
        FormComponent={InfosilemReaderForm}
        schemaResolver={infosilemReaderValidationSchema}
      />
    </NodeProvider>
  );
}
